const removeDropdownOnMobile = () => {
    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    if (vw < 1025 && document.querySelector('.menu-item-has-children')) {
        const bigMenus = document.querySelectorAll('.menu-item-has-children');
        bigMenus.forEach(menu => {
            if (!menu.classList.contains('menu-item-has-children-modified')) {
                menu.classList.add('menu-item-has-children-modified');
                const parent = menu.parentElement;
                const allChildren = menu.querySelectorAll('.menu-item');
                if (allChildren.length > 0) {
                    allChildren.forEach(child => {
                        let clone = child.cloneNode(true);
                        clone.classList.add('kruse-mobile-menu-dropdown-item');
                        let labelHolder = clone.querySelector('.kruse-dropdown-card-label');
                        let label = labelHolder.innerHTML;
                        label = label.replace('&gt;', '');
                        labelHolder.innerHTML = label;
                        clone.setAttribute('data-parent-id', menu.id)
                        parent.insertBefore(clone, menu);
                    })
                    menu.classList.add('d-none');
                }
            }

        })
        // change contact link label
        if(!document.querySelector('.kruse-contact-link-mobile')){
            const contactLinks = document.querySelectorAll('.kruse-contact-link');
            if(contactLinks.length > 0){
                contactLinks.forEach(link => {
                    let mobileLabel = link.getAttribute('data-mobile-label');
                    let oldLabel = link.innerHTML;
                    link.setAttribute('data-mobile-label', oldLabel);
                    link.innerHTML = mobileLabel;
                    link.classList.add('kruse-contact-link-mobile');
                })
            }
        }


    }
    if (vw > 1024 && document.querySelector('.menu-item-has-children-modified')) {
        const toggler = document.querySelector('.navbar-toggler');
        if (!toggler.classList.contains('collapsed')) {
            toggler.click();
        }
        const allClones = document.querySelectorAll('.kruse-mobile-menu-dropdown-item');
        if (allClones.length > 0){
            allClones.forEach(clone =>{
                clone.parentElement.removeChild(clone);
            })
        }
        const bigMenus = document.querySelectorAll('.menu-item-has-children-modified');
        bigMenus.forEach(menu => {
            menu.classList.remove('d-none')
            menu.classList.remove('menu-item-has-children-modified')
        })
        // change contact link label
        if(document.querySelector('.kruse-contact-link-mobile')){
            const contactLinks = document.querySelectorAll('.kruse-contact-link-mobile');
            if(contactLinks.length > 0){
                contactLinks.forEach(link => {
                    let mobileLabel = link.getAttribute('data-mobile-label');
                    let oldLabel = link.innerHTML;
                    link.setAttribute('data-mobile-label', oldLabel);
                    link.innerHTML = mobileLabel;
                    link.classList.remove('kruse-contact-link-mobile');
                })
            }
        }


    }
}
export default removeDropdownOnMobile;